<template>
    <div>
        <footer>
            <div class="container sitemap text-center">
                <h2>{{$t('message.site_map')}}</h2>
                <ul id="sitemapul">
                    <li class="nav-item"><router-link to="/about-part" class="nav-link"> {{$t('message.about_management')}}</router-link></li>
                    <li class="nav-item"><router-link to="/#objectspart" class="nav-link">{{$t('message.ppp_objects')}}</router-link></li>
                    <li class="nav-item"><router-link to="/realized-objects" class="nav-link"> {{$t('message.realized_objects')}}</router-link></li>
                    <li class="nav-item"><router-link to="/private-schools" class="nav-link"> {{$t('message.private_schools')}}</router-link></li>
                    <li class="nav-item"><router-link to="/#faqpart" class="nav-link"> {{$t('message.faq')}}</router-link></li>
                    <li class="nav-item"><router-link to="/contact-us" class="nav-link"> {{$t('message.contact_us')}}</router-link></li>
                </ul>
                <hr>
                <h6>{{$t('message.ministry_footer')}}<br>© 2023</h6>
            </div>
        </footer>
        <div class="webeonmark text-center">
            <h6>{{$t('message.webeonmark')}} <a href="https://itsm.uz/">   <img class="responsive m-2" width="35" src="/static/images/itsm_logo.png" alt=""/>ITSM.UZ</a></h6>
        </div>
    </div>
</template>

<script>
    export default {
        name: "the-footer",
    }
</script>
